import * as types from "../constants";

const initialState = {
  isLoading: true,
  error: null,
  items: [],
};

export default function fundsLifeCycleStatusReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case types.GET_FUNDS_LIFE_CYCLE_STATUS_INIT:
      return { ...state, error: null, isLoading: true };

    case types.GET_FUNDS_LIFE_CYCLE_STATUS_SUCCESS:
      return { ...state, isLoading: false, items: action.data.data };

    case types.GET_FUNDS_LIFE_CYCLE_STATUS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.notification.system_message,
      };

    default:
      return state;
  }
}
